module.exports = {
  bpSmall: "30rem",
  bpMedium: "48rem",
  bpLarge: "64rem",
  colorSand: "rgb(245, 245, 245)",
  colorEmail: "rgb(22, 50, 92)",
  colorFacebook: "rgb(59, 89, 152)",
  colorOcean: "rgb(0, 112, 210)",
  colorFog: "rgb(226, 226, 226)",
  colorBlack: "rgb(30, 30, 30)",
  colorCalypso: "rgb(43, 113, 142)",
  colorImportant: "rgb(251, 97, 14)",
  colorGranite: "rgb(173, 173, 173)",
  colorDestructive: "rgb(194, 57, 52)",
  colorSuccess: "rgb(4, 129, 73)",
  colorStormcloud: "rgb(145, 145, 145)",
  colorEvergreen: "rgb(4, 129, 73)",
  colorBrand: "rgb(0, 112, 210)",
  colorMidnight: "rgb(22, 50, 92)",
  colorWhite: "rgb(255, 255, 255)",
  colorTertiary: "rgb(88, 88, 88)",
  colorIce: "rgb(174, 186, 204)",
  colorMedium: "rgb(0, 171, 108)",
  colorMeteorite: "rgb(88, 88, 88)",
  colorFire: "rgb(251, 97, 14)",
  colorFraggle: "rgb(117, 117, 117)",
  colorAzure: "rgb(54, 95, 178)",
  colorGoogle: "rgb(234, 67, 53)",
  colorRuby: "rgb(194, 57, 52)",
  colorLink: "rgb(0, 112, 210)",
  colorTwitter: "rgb(29, 161, 242)",
  colorSecondary: "rgb(22, 50, 92)",
  colorDisabled: "rgb(173, 173, 173)",
  colorLinkedin: "rgb(0, 119, 181)",
  colorSunshine: "rgb(253, 181, 43)",
  colorSalesforce: "rgb(0, 161, 224)",
  colorLochinvar: "rgb(43, 142, 135)",
  colorRadio: "rgb(178, 95, 208)",
};